// @flow
import { createParser, fields } from '../utils/parse';
import Package from './packages';

export const Partner = createParser('Partner', {
  name: fields.string(''),
  slug: fields.string(''),
});

export const PackageLink = createParser('PackageLink', {
  id: fields.number(-1),
  type: fields.string(''),
  url: fields.string(''),
});

export const Seo = createParser('Seo', {
  metaTitle: fields.string('', { path: 'meta_title' }),
  metaDescription: fields.string('', { path: 'meta_description' }),
});

export const CardImageUrl = fields.object('CardImageMap', {
  transform: (imageObject: any) => {
    let {
      label: label = '',
      side_type: side = '',
      orientation_type: orientation = '',
      width,
      height,
      image,
      original_image: originalImage,
    } = imageObject;

    label = label ? label.toLowerCase() : '';
    side = side ? side.toLowerCase() : '';
    orientation = orientation ? orientation.toLowerCase() : '';

    let type;
    let aspectRatio;

    if ((label === 'front' || label === 'back') && side === 'paper') {
      type = 'card_' + orientation;
      aspectRatio =
        height > width ? 'portrait' : height < width ? 'landscape' : 'square';
    } else if (side === 'envelope') {
      type = 'envelope_' + orientation;
      aspectRatio = 'envelope';
    } else if (label === 'insert') {
      type = 'insert_' + orientation;
      aspectRatio = 'insert';
    } else {
      type = 'unknown';
      aspectRatio = 'unknown';
    }

    return {
      type,
      aspectRatio,
      width,
      height,
      image,
      originalImage,
    };
  },
});

export const SingleCard = createParser('SingleCard', {
  coins: fields.number(-1, { path: 'package.coins' }),
  id: fields.number(-1, { path: 'package.id' }),
  eventType: fields.string('', { path: 'package.event_type' }),
  name: fields.string('', { path: 'package.name' }),
  isNovelty: fields.bool(false, { path: 'package.is_novelty' }),
  images: fields.array(CardImageUrl, { path: 'images.online.sides' }),
  partner: fields.object(Partner, { path: 'package.partner' }),
  palette: fields.string('', { path: 'package.palette_url' }),
  link: fields.object(PackageLink, { path: 'package.link' }),
  availableInPaper: fields.bool(false, { path: 'package.available_in_paper' }),
  relatedCards: fields.array(Package, { path: 'suites' }),
  seo: fields.object(Seo, { path: 'seo' }),
});

export default SingleCard;
